import { styled, useTheme } from "@mui/material";
import React from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
const Amenities = dynamic(() => import("./").then((mod) => mod.Amenities));
const Area = dynamic(() => import("./").then((mod) => mod.Area));
const Budget = dynamic(() => import("./").then((mod) => mod.Budget));
const BusinessProfileType = dynamic(() => import("./").then((mod) => mod.BusinessProfileType));
const Furnishing = dynamic(() => import("./").then((mod) => mod.Furnishing));
const LandFacing = dynamic(() => import("./").then((mod) => mod.LandFacing));
const ListedBy = dynamic(() => import("./").then((mod) => mod.ListedBy));
const PropertyCategory = dynamic(() => import("./").then((mod) => mod.PropertyCategory));
const PropertyStatus = dynamic(() => import("./").then((mod) => mod.PropertyStatus));
const PropertyType = dynamic(() => import("./").then((mod) => mod.PropertyType));
const PurchaseType = dynamic(() => import("./").then((mod) => mod.PurchaseType));
// const ServiceSubtype = dynamic(() => import("./").then((mod) => mod.ServiceSubtype));
// const ServiceType = dynamic(() => import("./").then((mod) => mod.ServiceType));
const UnitFacing = dynamic(() => import("./").then((mod) => mod.UnitFacing));
const BedroomsVariant2 = dynamic(() => import("./").then((mod) => mod.BedroomsVariant2));
import { Typography, Divider } from "@mui/material";

import { Box, useMediaQuery } from "@mui/system";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import StateInterface from "../../redux-magic/state-interface";

// const BusinessProfileCard = dynamic(() => import("../cards/BusinessProfileCards/NewBusinessProfileCard"));

const PropertyCardGridView = dynamic(() => import("../cards/PropertyCardGridMiniTwo/PropertyCardFetcher"));
// const ServiceCardGridView = dynamic(() => import("../cards/ServiceCardGridMiniTwo/ServiceCardFetcher"));
const BeegruButton = dynamic(() => import("../common-components/buttons/BeegruButton"));

import SearchAfterAnimationComplete from "./SearchAfterAnimationComponent";
import SearchMobile from "./SearchMobile/SearchMobile";
const AppliedFilters = dynamic(() => import("./AppliedFilters"));
import PpsfChips from "./PpsfChips";

const CustomDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "flex-start",
	paddingTop: "4rem" /* XXS breakpoint */,
	[theme.breakpoints.only("xxs")]: {
		padding: "0rem 0.5rem 0rem 0.5rem",
	},
	/* XS breakpoint */
	[theme.breakpoints.only("xs")]: {
		padding: "0rem 0.75rem 0rem 0.75rem",
	},
	/* XSPLUS breakpoint */
	[theme.breakpoints.only("xsPlus")]: {
		padding: "0rem 1.5rem 0rem 1.5rem",
	},
	/* SM breakpoint */
	[theme.breakpoints.only("sm")]: {
		padding: "0rem 3rem 0rem 3rem",
	},
	/* SMPLUS breakpoint */
	[theme.breakpoints.only("smPlus")]: {
		padding: "0rem 3rem 0rem 3rem",
	},
	/* SM822 breakpoint */
	[theme.breakpoints.only("sm822")]: {
		padding: "0rem 3rem 0rem 3rem",
	},
	/* SM860 breakpoint */
	[theme.breakpoints.only("sm860")]: {
		padding: "0rem 3rem 0rem 3rem",
	},
	/* SM860 breakpoint */
	[theme.breakpoints.only("sm910")]: {
		padding: "0rem 3rem 0rem 3rem",
	},
	/* MD breakpoint */
	[theme.breakpoints.only("md")]: {
		padding: "0rem 4rem 0rem 4rem",
	},
	/* MD1190 breakpoint */
	[theme.breakpoints.only("md1190")]: {
		padding: "0rem 4rem 0rem 4rem",
	},
	/* MD1220 breakpoint */
	[theme.breakpoints.only("md1220")]: {
		padding: "0rem 4rem 0rem 4rem",
	},
	/* LG breakpoint */
	[theme.breakpoints.only("lg")]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 4rem 0rem 4rem",
	},
	/* LGPLUS breakpoint */
	[theme.breakpoints.up("lgPlus")]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 5rem 0rem 5rem",
	},
	[theme.breakpoints.up(1500)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 10rem 0rem 10rem",
	},
	[theme.breakpoints.up(1640)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 15rem 0rem 15rem",
	},
	[theme.breakpoints.up(1780)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 18rem 0rem 18rem",
	},
	/* 1080p XL breakpoint */
	[theme.breakpoints.up("xl")]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 18rem 0rem 18rem",
	},
	[theme.breakpoints.up(2020)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 26rem 0rem 26rem",
	},
	[theme.breakpoints.up(2120)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 29rem 0rem 29rem",
	},
	[theme.breakpoints.up(2220)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 32rem 0rem 32rem",
	},
	[theme.breakpoints.up(2350)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 39rem 0rem 39rem",
	},
	/* 2K XXL breakpoint */
	[theme.breakpoints.up("xxl")]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 36rem 0rem 36rem",
	},
	[theme.breakpoints.up(2800)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 39rem 0rem 39rem",
	},
	[theme.breakpoints.up(2900)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 40rem 0rem 40rem",
	},
	[theme.breakpoints.up(3000)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 42rem 0rem 42rem",
	},
	[theme.breakpoints.up(3100)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 47rem 0rem 47rem",
	},
	[theme.breakpoints.up(3200)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 52rem 0rem 52rem",
	},
	[theme.breakpoints.up(3300)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 57rem 0rem 57rem",
	},
	[theme.breakpoints.up(3400)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 62rem 0rem 62rem",
	},
	[theme.breakpoints.up(3500)]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 67rem 0rem 67rem",
	},
	/* 4K XXXL breakpoint */
	[theme.breakpoints.up("xxxl")]: {
		// position: "absolute",
		// zIndex: 1,
		padding: "0rem 72rem 0rem 72rem",
	},
	[theme.breakpoints.down("md1190")]: {
		display: "flex",
		justifyContent: "flex-start",
		width: "100%",
	},
}));

const RowDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	width: "100%",
	gap: "1rem",
	padding: "0.5rem 0rem 0rem 0rem",
	marginTop: "6.5rem",

	[theme.breakpoints.up("sm")]: {
		paddingTop: "1rem 0rem 0rem 0rem",
	},
	[theme.breakpoints.down("md1190")]: {
		marginTop: "0rem",
		height: "auto",
	},
}));

const SnackbarContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	width: "100%",
	marginBottom: "0.5rem",
	[theme.breakpoints.down("md1220")]: {
		justifyContent: "flex-start",
		// gap: "0.5rem",
	},
}));

const DesktopFilterDiv = styled("div")(({ theme }) => ({
	display: "flex",
	position: "sticky",
	top: 200,
	flexDirection: "column",
	width: "25%",
	gap: "1rem",
	maxHeight: "calc(100vh - 13rem)",
	overflowY: "auto",
	paddingBottom: "0.5rem",
	paddingRight: "0.75rem",
	"&::-webkit-scrollbar": {
		display: "none",
	},
	scrollbarWidth: "none", // Firefox
	"-ms-overflow-style": "none", // IE and Edge
	[theme.breakpoints.down("md1190")]: {
		display: "none",
	},
}));

const DesktopFilterDivSomething = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "flex-start",
	width: "100%",
	height: "100%",
	overflowY: "auto",
	gap: "0.5rem",
	rowGap: "0.75rem",
	flexWrap: "wrap",
	padding: "0rem 0rem 0rem 0rem",
	// [theme.breakpoints.up("xxs")]: {
	// 	padding: "0rem 0.5rem 0rem 0.5rem",
	// },
	// /* XS breakpoint */

	// [theme.breakpoints.up("xs")]: {
	// 	padding: "0rem 0.75rem 0rem 0.75rem",
	// },
	// /*galaxy S8+ - 360*/
	[theme.breakpoints.up(theme.breakpoints.values.xs + 78)]: {
		// gap: "0.5rem", // 3 cards
		// rowGap: "0.75rem", //3 cards
		gap: "0.75rem", // 2 cards
		rowGap: "0.75rem", // 2cards
	},
	// /*iphone 14 pro max - 430*/
	[theme.breakpoints.up(theme.breakpoints.values.xs + 149)]: {
		// gap: "0.5rem", // 3 cards
		// rowGap: "0.75rem", //3 cards
		gap: "1rem", // 2 cards
		rowGap: "1rem", // 2 cards
	},
	// /* XSPLUS breakpoint */
	// [theme.breakpoints.up("xsPlus")]: {
	// 	padding: "0rem 1.5rem 0rem 1.5rem",
	// },
	// /* SM breakpoint */
	// [theme.breakpoints.only("sm")]: {
	// 	padding: "0rem 3rem 0rem 3rem",
	// },
	[theme.breakpoints.up("sm")]: {
		padding: "0rem ",
	},
	/* MD breakpoint */
	[theme.breakpoints.up(theme.breakpoints.values.md + 147)]: {
		gap: "1rem",
		rowGap: "1rem",
	},
	[theme.breakpoints.up("md1190")]: {
		width: "75%",
	},
}));

const LoadMoreDiv = styled("div")(({ theme }) => ({
	width: "100%",
	pointerEvents: "none",
	cursor: "none",
	background: "transparent",
	alignItems: "center",
}));

const BannerDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "flex-start",
	width: "100%",
	height: "auto",
	margin: "1rem 0rem 0rem 0rem",
}));

const PPSFDetailsDiv = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	background: theme.palette.background.paper,
	padding: "1rem",
	borderRadius: "1rem",
}));

const FilterComponents = ({
	total_property_ids,
	search_filter_state,
	dispatch,
	searchanimationsettings,
	session,
	profile_context,
	CollectionName,
	searchLocation,
	login_flow_global_state,
	initialLoad,
	pageTitle,
	pageSubtitle,
}: {
	search_filter_state: StateInterface["search_filters_state"];
	dispatch: Function;
	searchanimationsettings: StateInterface["search_animation_settings"];
	session: any;
	profile_context: any;
	CollectionName: any;
	searchLocation: any;
	login_flow_global_state: StateInterface["login_flow_global_state"];
	total_property_ids: any;
	initialLoad: boolean;
	pageTitle: string;
	pageSubtitle: string;
}) => {
	const theme = useTheme();

	const router = useRouter();

	const smDevice = useMediaQuery(theme.breakpoints.down("sm"));
	const [PropertyIDs, setPropertyIDs] = React.useState<string[]>([]);
	const [loadedCount, setLoadedCount] = React.useState(9);
	React.useEffect(() => {
		setPropertyIDs(smDevice ? total_property_ids.slice(0, 8) : total_property_ids.slice(0, 9));
		setLoadedCount(smDevice ? 8 : 9);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleLoadMore = () => {
		const nextCount = loadedCount + (smDevice ? 8 : 9);
		setPropertyIDs(total_property_ids.slice(0, nextCount));
		setLoadedCount(nextCount);
	};
	/*

		* show spinner or show end of results message

		*/

	let displayPropertyStatus = true;

	switch (search_filter_state.property_type.selected_options[0]?.id) {
		case "land_residential":
		case "land_commercial":
		case "land_agricultural":
		case "land_industrial":
		case "mining":
			displayPropertyStatus = false;
	}
	const [showFullSubtitle, setShowFullSubtitle] = React.useState(false);

	const words = pageSubtitle.split(/\s+/);
	const isLong = words.length > 25;
	const displayedText = showFullSubtitle ? pageSubtitle : words.slice(0, 27).join(" ");

	const PPSFDetailsComponent = () => (
		<Box>
			<PPSFDetailsDiv>
				<Typography
					variant="h5"
					gutterBottom
				>
					{pageTitle}
				</Typography>
				<Typography
					variant="button"
					gutterBottom
					sx={{ display: "block", textTransform: "none", color: "rgba(102, 102, 102, 1)" }}
				>
					{displayedText}
					{isLong && !showFullSubtitle && (
						<span
							style={{ color: "#FC8019", cursor: "pointer", marginLeft: "0.5em" }}
							onClick={() => setShowFullSubtitle(true)}
						>
							... Read more
						</span>
					)}
					{isLong && showFullSubtitle && (
						<span
							style={{ color: "#FC8019", cursor: "pointer", marginLeft: "0.5em" }}
							onClick={() => setShowFullSubtitle(false)}
						>
							Read less
						</span>
					)}
				</Typography>
				<Typography
					variant="button"
					gutterBottom
					sx={{ display: "block", textTransform: "none", color: "#FC8019", marginBottom: "1rem" }}
				>
					Showing Results : {total_property_ids.length}
				</Typography>{" "}
				<Box
					sx={{
						[theme.breakpoints.down("md1190")]: {
							display: "none",
						},
					}}
				>
					<Divider />
					<PpsfChips
						search_filter_state={search_filter_state}
						dispatch={dispatch}
					/>
				</Box>
			</PPSFDetailsDiv>
		</Box>
	);

	/*

	* Getting the index of banner_location from PropertyIds

	*/

	const ComponentToRender = PropertyIDs.map((propertyId: any, key: any) => {
		/*

		* Lets check if the propertyId banner_location exists or not.
		* bannerLocationIndex === -1 this is to check if the banner_location is not present in the PropertyIds. if not its a relavant property
		* if it is then lets set the DivId to relevant_property or unrelevant_property

		*/
		const DivId = "PPSF";
		// const renderMobileCard = () => {
		// 	const DivId = "PPSF";
		// 	switch (CollectionName) {
		// 		case "properties":
		// 			return (
		// 				<PropertyCardGridView
		// 					PropertyId={propertyId}
		// 					id={DivId}
		// 					dispatch={dispatch}
		// 					session={session}
		// 					profile_context={profile_context}
		// 					source="ppsf"
		// 					key={key}
		// 					search_log_id={"PPSF_search_log"}
		// 					// filter_hash={search_api_response?.filter_hash as string}
		// 					login_flow_global_state={login_flow_global_state}
		// 				/>
		// 			);
		// 		case "business_profiles":
		// 			return (
		// 				<BusinessProfileCard
		// 					_id={propertyId}
		// 					dispatch={dispatch}
		// 					source="ppsf"
		// 					bp_carousel_width_height={0 + "x" + 0}
		// 					session={session}
		// 					key={key}
		// 				/>
		// 			);
		// 		case "services":
		// 			return (
		// 				<ServiceCardGridView
		// 					ServiceId={propertyId}
		// 					dispatch={dispatch}
		// 					session={session}
		// 					profile_context={profile_context}
		// 					source="ppsf"
		// 					key={key}
		// 					login_flow_global_state={login_flow_global_state}
		// 				/>
		// 			);
		// 		default:
		// 			return null;
		// 	}
		// };

		return (
			<PropertyCardGridView
				PropertyId={propertyId}
				id={DivId}
				dispatch={dispatch}
				session={session}
				profile_context={profile_context}
				source="ppsf"
				key={key}
				search_log_id={"PPSF_search_log"}
				// filter_hash={search_api_response?.filter_hash as string}
				login_flow_global_state={login_flow_global_state}
			/>
		);
	});

	const [showAdvancedFilters, setShowAdvancedFilters] = React.useState(false);

	let BudgetTrigger = search_filter_state.business_profile_type.is_applied ? true : false;
	const smDown = useMediaQuery(theme.breakpoints.down("sm"));
	const md1190Up = useMediaQuery(theme.breakpoints.up("md1190"));

	return (
		<React.Fragment>
			<SnackbarContainer>
				<SearchAfterAnimationComplete
					dispatch={dispatch}
					search_filter_state={search_filter_state}
					searchanimationsettings={searchanimationsettings}
					searchLocation={searchLocation}
				/>
				{!md1190Up ? (
					<SearchMobile
						search_filter_state={search_filter_state}
						dispatch={dispatch}
						searchanimationsettings={searchanimationsettings}
						// search_filters_metrices={search_filters_metrices}
						// search_api_response={search_api_response}
					/>
				) : null}
			</SnackbarContainer>

			<CustomDiv
				sx={{
					"@keyframes CustomFadeOut": {
						"0%": { opacity: 0 },
						"25%": { opacity: 0 },
						"50%": { opacity: 0 },
						"75%": { opacity: 0.5 },
						"100%": { opacity: 1 },
					},
					// animation: "none",
					padding: "0rem 0rem 0.5rem 0rem",
					direction: router.locale === "ar-AE" ? "rtl" : "ltr",
				}}
			>
				<RowDiv>
					{md1190Up ? (
						<DesktopFilterDiv>
							<AppliedFilters
								search_filter_state={search_filter_state}
								dispatch={dispatch}
								searchanimationsettings={searchanimationsettings}
								search_type={search_filter_state.search_type?.selected_options[0]?.id as string}
							/>
							{!BudgetTrigger && search_filter_state.budget.is_visible && (
								<Budget
									search_id="budget"
									dispatch={dispatch}
									budget={search_filter_state.budget}
									transaction_type={search_filter_state.transaction_type}
									search_filter_state={search_filter_state}
								/>
							)}
							{/* {search_filter_state.service_type.is_visible && !search_filter_state.property_type.is_visible && (
								<ServiceType
									search_id="service_type"
									service_category_value={search_filter_state.service_category?.selected_options[0]?.value as string}
									dispatch={dispatch}
									service_type={search_filter_state.service_type}
									searchanimationsettings={searchanimationsettings}
								/>
							)}
							{search_filter_state.service_subtype.is_visible && !search_filter_state.property_type.is_visible && (
								<ServiceSubtype
									search_id="service_subtype"
									service_type_value={search_filter_state.service_type?.selected_options[0]?.id as string}
									dispatch={dispatch}
									service_subtype={search_filter_state.service_subtype}
									searchanimationsettings={searchanimationsettings}
								/>
							)} */}
							{search_filter_state.property_category.is_visible && !search_filter_state.service_type.is_visible && (
								<PropertyCategory
									search_id="property_category"
									property_category={search_filter_state.property_category}
									dispatch={dispatch}
									search_filter_state={search_filter_state}
									searchanimationsettings={searchanimationsettings}
								/>
							)}
							{search_filter_state.property_category?.selected_options[0]?.id !== "warehousing" &&
								search_filter_state.property_type.is_visible &&
								!search_filter_state.service_type.is_visible &&
								!["public_infrastructure", "joint_development", "joint_venture"].includes(
									search_filter_state.property_category?.selected_options[0]?.id,
								) && (
									<PropertyType
										search_id="property_type"
										property_category_value={
											search_filter_state.property_category?.selected_options[0]?.value as string
										}
										dispatch={dispatch}
										property_type={search_filter_state.property_type}
										searchanimationsettings={searchanimationsettings}
										search_filter_state={search_filter_state}
									/>
								)}
							{!BudgetTrigger && search_filter_state.listed_by.is_visible && (
								<ListedBy
									search_id="listed_by"
									listed_by={search_filter_state.listed_by}
									dispatch={dispatch}
									isService={search_filter_state.search_type.selected_options[0]?.title === "Services" ? true : false}
									searchanimationsettings={searchanimationsettings}
									search_filter_state={search_filter_state}
								/>
							)}
							{/* {search_filter_state.transaction_type.is_applied &&
								!search_filter_state.transaction_type.selected_options[0].title.includes("Resale") &&
								!search_filter_state.transaction_type.selected_options[0].title.includes("Rent") &&
								search_filter_state.property_category.is_applied && (
									<PurchaseType
										search_id="transaction_type"
										dispatch={dispatch}
										searchanimationsettings={searchanimationsettings}
										search_filter_state={search_filter_state}
									/>
								)} */}
							{/* {search_filter_state.bedrooms.is_visible && search_filter_state.property_type.is_visible && (
							<Bedrooms
								search_id="bedrooms"
								dispatch={dispatch}
								bedrooms={search_filter_state.bedrooms}
							/>
						)} */}
							{search_filter_state.bedrooms_variant_2.is_visible && search_filter_state.property_type.is_visible && (
								<BedroomsVariant2
									search_id="bedrooms_variant_2"
									dispatch={dispatch}
									bedrooms={search_filter_state.bedrooms_variant_2}
									searchanimationsettings={searchanimationsettings}
									search_filter_state={search_filter_state}
								/>
							)}
							{search_filter_state.property_type.is_applied &&
								(search_filter_state.property_type?.selected_options[0]?.id.includes("plot") ||
									search_filter_state.property_type?.selected_options[0]?.id.includes("land")) && (
									<Area
										search_id="area"
										dispatch={dispatch}
										area={search_filter_state.area}
										searchanimationsettings={searchanimationsettings}
										search_filter_state={search_filter_state}
									/>
								)}
							{showAdvancedFilters &&
								search_filter_state.area.is_visible &&
								search_filter_state.property_type.is_visible &&
								!search_filter_state.property_type?.selected_options[0]?.id.includes("plot") &&
								!search_filter_state.property_type?.selected_options[0]?.id.includes("land") && (
									<Area
										search_id="area"
										dispatch={dispatch}
										area={search_filter_state.area}
										searchanimationsettings={searchanimationsettings}
										search_filter_state={search_filter_state}
									/>
								)}
							{showAdvancedFilters &&
								search_filter_state.property_status.is_visible &&
								displayPropertyStatus &&
								search_filter_state.property_type.is_visible && (
									<PropertyStatus
										search_id="property_status"
										dispatch={dispatch}
										property_status={search_filter_state.property_status}
										property_type={search_filter_state.property_type}
										transaction_type={search_filter_state.transaction_type}
										posession_date={search_filter_state.possession_date}
										search_filter_state={search_filter_state}
									/>
								)}
							{showAdvancedFilters &&
								search_filter_state.unit_facing.is_visible &&
								search_filter_state.property_type.is_visible &&
								router.locale !== "ar-AE" && (
									<UnitFacing
										search_id="unit_facing"
										dispatch={dispatch}
										unit_facing={search_filter_state.unit_facing}
										searchanimationsettings={searchanimationsettings}
										search_filter_state={search_filter_state}
									/>
								)}
							{showAdvancedFilters &&
								search_filter_state.land_facing.is_visible &&
								search_filter_state.property_type.is_visible &&
								router.locale !== "ar-AE" && (
									<LandFacing
										search_id="land_facing"
										dispatch={dispatch}
										land_facing={search_filter_state.land_facing}
										searchanimationsettings={searchanimationsettings}
										search_filter_state={search_filter_state}
									/>
								)}
							{showAdvancedFilters &&
								search_filter_state.furnishing.is_visible &&
								search_filter_state.property_type.is_visible && (
									<Furnishing
										search_id="furnishing"
										dispatch={dispatch}
										furnishing={search_filter_state.furnishing}
										searchanimationsettings={searchanimationsettings}
										search_filter_state={search_filter_state}
									/>
								)}
							{/* {showAdvancedFilters && search_filter_state.security_deposit.is_visible && (
							<SecurityDeposit
								search_id="security_deposit"
								dispatch={dispatch}
								security_deposit={search_filter_state.security_deposit}
							/>
						)} */}
							{showAdvancedFilters &&
								search_filter_state.amenities.is_visible &&
								search_filter_state.property_type.is_visible && (
									<Amenities
										search_id="amenities"
										dispatch={dispatch}
										amenities={search_filter_state.amenities}
										searchanimationsettings={searchanimationsettings}
										search_filter_state={search_filter_state}
									/>
								)}
							{/* {showAdvancedFilters &&
							search_filter_state.balconies.is_visible &&
							search_filter_state.property_type.is_visible && (
								<Balconies
									search_id="balconies"
									dispatch={dispatch}
									balconies={search_filter_state.balconies}
								/>
							)} */}
							{/* {showAdvancedFilters &&
							search_filter_state.bathrooms.is_visible &&
							search_filter_state.property_type.is_visible && (
								<Bathrooms
									search_id="bathrooms"
									dispatch={dispatch}
									bathrooms={search_filter_state.bathrooms}
								/>
							)} */}
							{/* {showAdvancedFilters &&
							search_filter_state.bathrooms_variant_2.is_visible &&
							search_filter_state.property_type.is_visible && (
								<BathroomsVariant2
									search_id="bathrooms_variant_2"
									dispatch={dispatch}
									bathrooms={search_filter_state.bathrooms_variant_2}
								/>
							)} */}
							{/* {search_filter_state.plot_dimensions.is_visible && search_filter_state.property_type.is_visible && (
							<PlotDimensions
								search_id="plot_dimensions"
								dispatch={dispatch}
								plot_dimensions={search_filter_state.plot_dimensions}
							/>
						)} */}
							{/* {search_filter_state.possession_date.is_visible && search_filter_state.property_type.is_visible && (
							<PossessionDate
								search_id="possession_date"
								dispatch={dispatch}
								possession_date={search_filter_state.possession_date}
							/>
						)} */}
							{/* {search_filter_state.available_from.is_visible && search_filter_state.property_type.is_visible && (
							<AvailableFrom
								search_id="available_from"
								dispatch={dispatch}
								available_from={search_filter_state.available_from}
							/>
						)} */}
							{/* {showAdvancedFilters &&
							search_filter_state.floors.is_visible &&
							search_filter_state.property_type.is_visible && (
								<Floors
									search_id="floors"
									dispatch={dispatch}
									floors={search_filter_state.floors}
								/>
							)} */}
							{search_filter_state.business_profile_type.is_visible &&
								search_filter_state.business_profile_type.is_applied && (
									<BusinessProfileType
										search_id="business_profile_type"
										dispatch={dispatch}
										business_profile_type={search_filter_state.business_profile_type}
										searchanimationsettings={searchanimationsettings}
										search_filter_state={search_filter_state}
									/>
								)}
							{/* {showAdvancedFilters &&
							search_filter_state.balconies_variant_2.is_visible &&
							search_filter_state.property_type.is_visible && (
								<BalconiesVariant2
									search_id="balconies_variant_2"
									dispatch={dispatch}
									balconies={search_filter_state.balconies_variant_2}
								/>
							)} */}
							{search_filter_state.business_profile_type.is_applied ||
							search_filter_state.property_category?.selected_options[0]?.id === "warehousing" ||
							search_filter_state.search_type.selected_options[0]?.title === "Services" ||
							(search_filter_state.search_type.selected_options[0]?.title === "Properties" &&
								search_filter_state.property_type.is_applied === false) ? null : (
								<BeegruButton
									flavor="primary"
									variant="contained"
									size="large"
									sx={{
										dsiaplay: "flex",
										marginTop: "1rem",
										[theme.breakpoints.down("md")]: {
											width: "100%",
										},
									}}
									onClick={() => {
										setShowAdvancedFilters(!showAdvancedFilters);
									}}
								>
									{showAdvancedFilters
										? router.locale === "ar-AE"
											? "إخفاء الفلاتر المتقدمة"
											: router.locale === "kn-IN"
												? "ಉನ್ನತ ಫಿಲ್ಟರ್‌ಗಳನ್ನು ಮರುದರ್ಶಿಸಿ"
												: "Hide advanced filters"
										: router.locale === "ar-AE"
											? "إظهار الفلاتر المتقدمة"
											: router.locale === "kn-IN"
												? "ಉನ್ನತ ಫಿಲ್ಟರ್‌ಗಳನ್ನು ಮರುದರ್ಶಿಸಿ"
												: "Show advanced filters"}
								</BeegruButton>
							)}
							{/* <ServiceCategory
							search_id="service_category"
							dispatch={dispatch}
							service_category={search_filter_state.service_category}
						/> */}
						</DesktopFilterDiv>
					) : null}

					<DesktopFilterDivSomething>
						{PPSFDetailsComponent()}
						{ComponentToRender}
						{total_property_ids.length > 10 && total_property_ids.length !== PropertyIDs.length ? (
							<Box
								sx={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									width: "100%",
									height: smDevice ? "7rem" : "5rem",
									gap: "1.5rem",
								}}
							>
								<BeegruButton
									variant="contained"
									size="large"
									onClick={handleLoadMore}
									sx={{
										minWidth: "160px",
										fontSize: smDevice ? "0.875rem" : "1rem",
										borderRadius: "0.75rem",
									}}
									startIcon={<RefreshIcon />}
								>
									{router.locale === "ar-AE"
										? "تحميل المزيد"
										: router.locale === "kn-IN"
											? "ಮತ್ತಷ್ಟು ಲೋಡ್ ಮಾಡಿ"
											: "Load More"}
								</BeegruButton>
							</Box>
						) : (
							<></>
						)}
					</DesktopFilterDivSomething>
				</RowDiv>
			</CustomDiv>
		</React.Fragment>
	);
};

export default FilterComponents;
